var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',_vm._b({attrs:{"filter":_vm.searchQuery,"hide-no-data":"","solo":"","value":_vm.value},on:{"change":(val) => _vm.$emit('change', val)}},'v-autocomplete',{ ..._vm.$props },false))
}
var staticRenderFns = []

export { render, staticRenderFns }